import styled from 'styled-components';
import Drawer from 'antd/es/drawer';

export const StyledDrawer = styled(Drawer)`
  &&& {
    .setur-drawer-content-wrapper {
      height: 100% !important;
    }

    .setur-drawer-body {
      padding: 0px 0px;
      overflow: auto;
    }

    .setur-drawer-header {
      padding: 18px 16px;
      background: ${({ theme }) => theme.palette.grey1100};
    }

    .setur-drawer-header-title {
      display: flex;
      flex-direction: row-reverse;
      gap: 24px;
    }

    .setur-drawer-title {
      color: ${({ theme }) => theme.palette.white};
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }

    .setur-drawer-close {
      padding: 0px;
      margin: 0px;
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
  }
`;
